
export const USER_UPDATE_SUCCESS = "USER_UPDATE_SUCCESS"
export const USER_UPDATE_FAILURE = "USER_UPDATE_FAILURE"

export const USER_GRID_CHANGED = "USER_GRID_CHANGED"
export const USER_LIST_IMPORTED = "USER_LIST_IMPORTED"